const buildLocalStorageMock = () => {
  let store = {}
  return {
    _store: store,
    getItem (key) {
      return store[key] || null
    },
    setItem (key, value) {
      store[key] = value.toString()
    },
    removeItem (key) {
      delete store[key]
    },
    clear () {
      store = {}
    }
  }
}

const getLocalStorage = () => {
  try {
    return window.localStorage || window.sessionStorage
  } catch (e) {
    console.warn(e) // eslint-disable-line
    return buildLocalStorageMock()
  }
}
export { buildLocalStorageMock, getLocalStorage }
